// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-3lP4s";
var _3 = "aircraftImage-1_C24";
var _4 = "aircraftStatistics-14Q4U";
var _5 = "aircraftName-3hWs_";
var _6 = "active-1-NQW";
var _7 = "content-2R7YZ";
var _8 = "header-1sIHm";
var _9 = "routeInfo-1ujkp";
var _a = "airportsInfo-2gnib";
var _b = "controls-31GMk";
var _c = "bookLink-1OHEu";
var _d = "flightNumber-STQj4";
var _e = "status-pf4CC";
var _f = "departed-JPoXe";
var _10 = "scheduled-34bhD";
var _11 = "arrived-7fTV_";
var _12 = "cancelled-1CDmo";
var _13 = "dataExpected-2Pjjf";
var _14 = "date-Cf2OW";
var _15 = "airportInfo-1t4vJ";
var _16 = "time-dQYyM";
var _17 = "city-284Hr";
var _18 = "buyTicket-1kbcO";
var _19 = "duration-2w7_8";
var _1a = "departure-2gvh0";
var _1b = "arrival-3_0v7";
var _1c = "durationTime-28wuZ";
var _1d = "durationLine-2Y825";
export { _1 as "__esModule", _2 as "wrapper", _3 as "aircraftImage", _4 as "aircraftStatistics", _5 as "aircraftName", _6 as "active", _7 as "content", _8 as "header", _9 as "routeInfo", _a as "airportsInfo", _b as "controls", _c as "bookLink", _d as "flightNumber", _e as "status", _f as "departed", _10 as "scheduled", _11 as "arrived", _12 as "cancelled", _13 as "dataExpected", _14 as "date", _15 as "airportInfo", _16 as "time", _17 as "city", _18 as "buyTicket", _19 as "duration", _1a as "departure", _1b as "arrival", _1c as "durationTime", _1d as "durationLine" }
export default { "__esModule": _1, "wrapper": _2, "aircraftImage": _3, "aircraftStatistics": _4, "aircraftName": _5, "active": _6, "content": _7, "header": _8, "routeInfo": _9, "airportsInfo": _a, "controls": _b, "bookLink": _c, "flightNumber": _d, "status": _e, "departed": _f, "scheduled": _10, "arrived": _11, "cancelled": _12, "dataExpected": _13, "date": _14, "airportInfo": _15, "time": _16, "city": _17, "buyTicket": _18, "duration": _19, "departure": _1a, "arrival": _1b, "durationTime": _1c, "durationLine": _1d }
